import React from "react";
import PropTypes from "prop-types";
import LogoWhite from "../../assets/img/logo-white.png";
import {Link} from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import LockOutline from "@material-ui/icons/LockOutlined";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import {request} from "../../api-client";
import localization from "../../config/localization";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../components/Letflow/Snackbar/GlobalSnackbar";
import './register.css'
import queryString from 'querystring'
import {Instagram, Language, Person} from "@material-ui/icons";
import {getRefreshToken, homePathGenerator} from "../../api-client/core/authentication/utils";
import {getValueFromQueryParam} from "../../utils";

class ActiveUser extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      keepLogged: "keep",
    };
  }

  componentDidMount() {
    document.title = localization.get('title.activate') + ' - Bloomclouds'
    if (getRefreshToken()) {
      request.authentication.logout();
    }
  }

  activate = () => {
    if (this.state.password === this.state.confirmPassword) {
      this.setState({ requesting: true });
      request.authentication
        .activate({
          url: queryString.parse(this.props.location.search)["?url"],
          password: this.state.password
        })
        .then(response => {
          GlobalSnackbar.show({
            message: localization.get("activate.success"),
            type: GlobalSnackbarTypes.SUCCESS
          });

          if (response.email) {
            request.authentication
              .login({
                username: response.email,
                password: this.state.confirmPassword
              })
              .then(() => {
                  window.location.href = homePathGenerator('');
              })
              .catch(() => this.props.history.push("/login"));
          } else {
            this.props.history.push("/login");
          }
        })
        .catch(() => {
          GlobalSnackbar.show({
            message: localization.get("activate.activate_fail"),
            type: GlobalSnackbarTypes.ERROR
          });
          this.setState({ requesting: false });
        });
    } else {
      GlobalSnackbar.show({
        message: localization.get("activate.passwords_not_match"),
        type: GlobalSnackbarTypes.ERROR
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.content} style={{minHeight: "100vh", backgroundColor: "#7f7f7f"}}>
          <div className={"transparent-register-banner"}>
            <div style={{ flexGrow:1}}>
              <Link to="https://www.bloomclouds.com" target={"_blank"}>
                <img style={{ height: 35, flexGrow:1}} src={LogoWhite} alt="Logo Bloomclouds"/>
              </Link>
            </div>
            <div className={"banner-text"}>
              <p>{localization.get('bloomclouds.slogan')}</p>
            </div>
            <div className={"side-navbar"}>
              <Link to="https://www.instagram.com/bloomclouds" target={"_blank"}> <Instagram/> </Link>
              <Link to="https://www.bloomclouds.com" target={"_blank"}> <Language/> </Link>
              <Link to="/login" style={{padding: "12px 10px", fontSize: 16}}>Login</Link>
            </div>
          </div>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={6} md={6} lg={6} xl={8}>
                <form>
                  <Card register style={{opacity: "1!important", padding: "40px 60px"}}>
                    <h3 style={{textAlign: "center"}}>Crea tu cuenta para comenzar</h3>
                    <CardBody>
                      <CustomInput
                        labelText={localization.get('password')}
                        id="password"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockOutline
                                className={classes.inputAdornmentIcon}
                              />
                            </InputAdornment>
                          ),
                          onChange: e => this.setState({ password: e.target.value }),
                          type: 'password',
                          onKeyPress: e => {
                            if (e.key === 'Enter') {
                              e.preventDefault()
                              this.activate()
                            }
                          }
                        }}
                      />
                      <CustomInput
                        labelText={localization.get('repeat_password')}
                        id="confirmPassword"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockOutline
                                className={classes.inputAdornmentIcon}
                              />
                            </InputAdornment>
                          ),
                          onChange: e => this.setState({ confirmPassword: e.target.value }),
                          type: 'password',
                          onKeyPress: e => {
                            if (e.key === 'Enter') {
                              e.preventDefault()
                              this.activate()
                            }
                          }
                        }}
                      />
                    </CardBody>
                    <CardFooter className={classes.justifyContentCenter}>
                      <Button onClick={this.activate} color="default" style={{ backgroundColor: "black", maxWidth: 175, borderRadius: 5, fontWeight: "bold", marginTop: 15 }} simple block disabled={this.state.requesting}>{localization.get('active')}</Button>
                    </CardFooter>
                  </Card>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </React.Fragment>
    )
      ;
  }
}

ActiveUser.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(ActiveUser);
